import { render, staticRenderFns } from "./grid-merge-customers.vue?vue&type=template&id=689e378d&"
import script from "./grid-merge-customers.vue?vue&type=script&lang=js&"
export * from "./grid-merge-customers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports